/* unplugin-vue-components disabled */import { render } from "./QuestionTplEditorView.vue?vue&type=template&id=d25b3c18&scoped=true"
import script from "./QuestionTplEditorView.vue?vue&type=script&lang=js"
export * from "./QuestionTplEditorView.vue?vue&type=script&lang=js"

import "./QuestionTplEditorView.vue?vue&type=style&index=0&id=d25b3c18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25b3c18"]])

export default __exports__